module.exports = __webpack_public_path__ + "static/2021-08-20-18-11-54-470-fs8-92ebf80b22510895e9590bf66b5abce0.png";